module.exports = __webpack_public_path__ + "static/media/courier.e641b9d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/courier.jpg
// module id = 13904
// module chunks = 0